import $ from 'jquery';

//import todoistData from  "./todoist.test.json";
// import todoistConfig from  "./todoist.config.json";
import {TodoistSync} from "./components/Todoist/TodoistSync";
import SyncInterface = TodoistSync.SyncInterface;
import * as ReactDOM from "react-dom";
import * as React from "react";
import {ReactMain} from "./components/React/ReactTask";
import {SyncConverter} from "./components/Todoist/App";
import "./sass/index.scss"
import {TimeLine, Week} from "./components/React/TimeReserv";
import {TaskFilter} from "./components/Todoist/Task";
import {MainFilter, Menu} from "./components/React/Container";
import {todoistConfig} from "./components/Todoist/Auth";

//curl https://api.todoist.com/sync/v8/sync?token=c102049fbd78700e27ecc9b11b88a3252600ca30&sync_token=*&resource_types='["all", "-projects"]'


//let myObject : SyncInterface = todoistData;

interface MainInterface {
    $:any
    callBack(data:object):void
}

class Data implements MainInterface{

    constructor(jQuery: any){
        this.$ = jQuery;
    }

    $: any;
    callBack(todoistSync: SyncInterface): void {

        let sync =  (new SyncConverter(todoistSync)).convert();
        let tasks =  sync.tasks;
        tasks.sort((one, two) => { return one.getPriority().getId() > two.getPriority().getId() ? -1: 0});



        ReactDOM.render((
                <ReactMain tasks={tasks}/>
            ),
            document.getElementById("root"));

        ReactDOM.render(<TimeLine tasks={tasks}/>, document.getElementById("timeline"));


       // ReactDOM.render(<Week tasks={tasks}/>, document.getElementById("week"));

    }

}


function main(data: MainInterface){
    // localStorage.setItem('todoIstSync', JSON.stringify(testObject));

    ReactDOM.render((
            <Menu/>
        ),
        document.getElementById("header"));



// Retrieve the object from storage
    var retrievedObject: object = JSON.parse(localStorage.getItem('todoIstSync'));
    retrievedObject = undefined;
    if(!retrievedObject) {
        //labels, projects,items, notes, filters, reminders, locations, user, live_notifications, collaborators, user_settings, notification_settings
        document.getElementById("root").innerHTML="Loading...";

        let headers = {
            "Content-Type": "application/json"
            ,'Accept': 'application/json'
            ,"Authorization": `Bearer ${todoistConfig.apiKey}`

        }



        data.$.ajax(

            "https://api.todoist.com/api/v1/sync?token=" + todoistConfig.apiKey + "&sync_token=*&resource_types=[\"all\",\"-filters\",\"-notes\",\"-user\",\"-reminders\"]",


            {
                'method': "POST",
                'success':function (todoist: any) {
                    localStorage.setItem('todoIstSync', JSON.stringify(todoist));
                    data.callBack(todoist);

                },
                'headers': headers

            }



            );
    }else {
        data.callBack(retrievedObject);
    }
}



console.log($);
$(document).ready(function () {

    main(new Data($));

});


